module.exports = __webpack_public_path__ + "img/share_gold.8b28f69b.png";